<div *ngIf="hasImage(); then showImage else showDefault"></div>
<ng-template #showImage>
	<div class="sdp-image-container" [class.sdp-image-container-sm]="isSmall()">
		<img [src]="applicationImage.imageBase64" [alt]="applicationImage.name" width="{{ dimensions.width }}" height="{{ dimensions.height }}"
		/>
	</div>
</ng-template>
<ng-template #showDefault>
	<div class="sdp-applicaiton-image-none">
		<div class="sdp-image-replacement-container" [style.background-color]="imageColor" [class.sdp-image-replacement-container-sm]="isSmall()">
			<span>{{ getDisplayValue() }}</span>
		</div>
	</div>
</ng-template>